import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/subscriptions/billing-history.ts
import { Exception } from "@wbk/logger";
var getBillingHistory = () => __async(void 0, null, function* () {
  var _a;
  const url = "/subscriptions/billing-history";
  try {
    const data = yield fetchClient({ url });
    if (((_a = data.status) == null ? void 0 : _a.toLowerCase()) !== "success") {
      throw new Error("Failed to get billing history");
    }
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getBillingHistoryException",
      context: { tags: { journey: "subscribe" } }
    });
  }
});

export {
  getBillingHistory
};
//# sourceMappingURL=chunk-ZC4X5O7T.mjs.map